import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
import { denormalisedEntities, updatedEntities } from '../../util/data';
import { SEARCHABLE_TUTOR_LISTING } from '../../util/types';
export const ASSET_NAME = 'landing-page';

// ================ Action types ================ //
export const FETCH_TUTOR_LISTING_REQUEST = 'app/LandingPage/FETCH_TUTOR_LISTING_REQUEST';
export const FETCH_TUTOR_LISTING_SUCCESS = 'app/LandingPage/FETCH_TUTOR_LISTING_SUCCESS';
export const FETCH_TUTOR_LISTING_ERROR = 'app/LandingPage/FETCH_TUTOR_LISTING_ERROR';

// ================ Reducer ================ //
const initialState = {
  fetchListingRequest: false,
  fetchListingError: null,
  listings: null
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_TUTOR_LISTING_REQUEST:
      return { ...state, fetchListingRequest: true, fetchListingError: null, listings: null };
    case FETCH_TUTOR_LISTING_SUCCESS:
      return { ...state, fetchListingRequest: false, fetchListingError: null, listings: payload };
    case FETCH_TUTOR_LISTING_ERROR:
      return { ...state, fetchListingRequest: false, fetchListingError: payload, listings: null };
    default:
      return state;
  }
};

// ================ Selectors ================ //

// ================ Action creators ================ //

export const fetchTutorListingRequest = () => ({
  type: FETCH_TUTOR_LISTING_REQUEST,
  payload: {},
});
export const fetchTutorListingSuccess = data => ({
  type: FETCH_TUTOR_LISTING_SUCCESS,
  payload: data,
});
export const fetchTutorListingError = error => ({
  type: FETCH_TUTOR_LISTING_ERROR,
  payload: error,
  error: true,
});

// ================ Thunk ================ //

export const getProperResponseOfListing = (response, config) => {
  const responseEntries = response.data.data.length ? updatedEntities({}, response.data, { listingFields: config?.listing?.listingFields }) : {};
  const resources = response.data.data.length ? response.data.data.map((st) => ({ id: st.id, type: "listing" })) : [];
  const responseArray = response.data.data.length ? denormalisedEntities(responseEntries, resources, false) : [];
  return responseArray;
};

export const fetchListings = () => (dispatch, getState, sdk) => {
  dispatch(fetchTutorListingRequest());
  return sdk.listings.query({
    pub_searchableListingType: SEARCHABLE_TUTOR_LISTING,
    include: ['author', 'images']
  }).then(async resp => {
    const listings = await getProperResponseOfListing(resp);
    return dispatch(fetchTutorListingSuccess(listings));
  })
    .catch(err => {
      console.log(err, "error fetching listing");
      return dispatch(fetchTutorListingError(err));
    });
};

export const loadData = (params, search) => dispatch => {
  const pageAsset = { landingPage: `content/pages/${ASSET_NAME}.json` };
  return Promise.all([dispatch(fetchListings()), dispatch(fetchPageAssets(pageAsset, true))]);
};
